import React, { FC } from "react";
import support from "../../assets/images/help.svg";
import two47 from "../../assets/images/24-hours.svg";
import fastTime from "../../assets/images/fast-time.svg";

export const Features: FC<{}> = () => {
  return (
    <section className="features-section">
      <div className="container">
        <div className="heading">
          <h2>
            As Fast As <span>Lightning.</span>
          </h2>
        </div>
        <div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="content">
                <div className="feature">
                  <div>
                    <div className="icon">
                      <img src={two47} alt="icon" />
                    </div>
                    <h2>Online 24/7</h2>
                  </div>
                  <div className="caption">
                    <p>
                      We are always online. You can buy and sell any time you
                      want and we’ll deliver.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="content">
                <div className="feature">
                  <div>
                    <div className="icon">
                      <img src={support} alt="icon" />
                    </div>
                    <h2>Heroic Support</h2>
                  </div>
                  <div className="caption">
                    <p>
                      Contact us any time to ask anything, we’ll answer you. We
                      are here to help
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12  col-lg-4">
              <div className="content">
                <div className="feature">
                  <div>
                    <div className="icon">
                      <img src={fastTime} alt="icon" />
                    </div>
                    <h2>Fast Payments</h2>
                  </div>
                  <div className="caption">
                    <p>
                      We pay you as soon as we verify your payments. No delays
                      at all.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
